import { render, staticRenderFns } from "./PreviewQuotedMessage.vue?vue&type=template&id=2817c990&"
import script from "./PreviewQuotedMessage.vue?vue&type=script&lang=js&"
export * from "./PreviewQuotedMessage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewQuotedMessage.vue?vue&type=style&index=0&id=2817c990&prod&lang=css&"
import style1 from "./PreviewQuotedMessage.vue?vue&type=style&index=1&id=2817c990&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports